(function (root, factory) {
  'use strict';
  var api = factory(root);
  if (typeof module === 'object' && module.exports) module.exports = api;
  else root.WtxFulfillment = api;
}(typeof window !== 'undefined' ? window : null, function (root) {
  'use strict';
  var property = 'WTX fulfillment';
  var cleanupMarker = '_WTX fulfillment cleanup';
  var routeProperties = ['WTX requested area', 'WTX route run', 'WTX route key', 'WTX route date', 'WTX route stop', 'WTX route cutoff', 'WTX route status'];
  function normalize(value) {
    return value === 'local' || value === 'delivery' ? 'local_delivery' : ['shipping', 'pickup', 'local_delivery'].includes(value) ? value : '';
  }
  function planId(line) {
    return String(line.selling_plan_allocation && line.selling_plan_allocation.selling_plan && line.selling_plan_allocation.selling_plan.id || line.selling_plan || '');
  }
  function stableProperties(properties, omitIntent) {
    return Object.keys(properties || {}).filter(function (key) { return !omitIntent || key !== property && key !== 'Fulfillment preference' && key !== cleanupMarker && !routeProperties.includes(key); }).sort().map(function (key) { return [key, properties[key]]; });
  }
  function deliveryProperties(line, facts, method, route) {
    var props = Object.assign({}, line.properties || {});
    if (facts.frozen) delete props['Fulfillment preference'];
    if (facts.frozen && (method === 'shipping' || props[property] !== method || route)) routeProperties.forEach(function (key) { delete props[key]; });
    if (facts.frozen) {
      props[property] = method;
      if (method !== 'shipping' && route) routeProperties.forEach(function (key) { if (typeof route[key] === 'string' && route[key]) props[key] = route[key]; });
    } else delete props[property];
    if (!Object.keys(props).length && Object.keys(line.properties || {}).length) props[cleanupMarker] = '1';
    return props;
  }
  function identity(cart, omitIntent) {
    var quantities = new Map();
    (cart.items || []).forEach(function (line) {
      var key = JSON.stringify([String(line.variant_id || line.id), planId(line), stableProperties(line.properties, omitIntent)]);
      quantities.set(key, (quantities.get(key) || 0) + line.quantity);
    });
    return JSON.stringify(Array.from(quantities).sort(function (a, b) { return a[0].localeCompare(b[0]); }));
  }
  function classifier(items) {
    var map = new Map();
    (items || []).forEach(function (item) {
      if (item && item.id && typeof item.frozen === 'boolean') map.set(String(item.id), item);
    });
    return function (line) {
      if (line.requires_shipping === false) return { frozen: false, shippingAllowed: true, grams: 0 };
      return map.get(String(line.variant_id || line.id)) || null;
    };
  }
  function analyze(cart, classify) {
    var frozen = [], unknown = [], methods = new Set(), missing = false, grams = 0, restricted = false, recurring = new Map(), recurringUnknown = false;
    (cart.items || []).forEach(function (line) {
      var facts = classify(line);
      if (!facts) { unknown.push(line); return; }
      if (!facts.frozen) return;
      frozen.push(line);
      var method = normalize(line.properties && line.properties[property]);
      if (!method || method !== (line.properties || {})[property]) missing = true;
      else methods.add(method);
      if (typeof facts.grams !== 'number' || !Number.isFinite(facts.grams) || facts.grams <= 0) unknown.push(line);
      else {
        var lineGrams = facts.grams * line.quantity;
        grams += lineGrams;
        if (line.selling_plan_allocation || line.selling_plan) {
          var id = planId(line);
          if (!/^[1-9][0-9]*$/.test(id)) recurringUnknown = true;
          else recurring.set(id, (recurring.get(id) || 0) + lineGrams);
        }
      }
      if (facts.shippingAllowed === false) restricted = true;
    });
    var method = !missing && methods.size === 1 ? Array.from(methods)[0] : '';
    var recurringError = recurringUnknown ? 'refill_plan_unavailable' : '';
    if (!recurringError && recurring.size && method && method !== 'shipping') recurringError = 'refill_route_schedule';
    if (!recurringError && method === 'shipping' && Array.from(recurring.values()).some(function (weight) { return weight < 18143.6; })) recurringError = 'refill_minimum';
    return { frozen: frozen, unknown: unknown, method: method, conflict: methods.size > 1, grams: grams, restricted: restricted, recurringGroups: Array.from(recurring).map(function (entry) { return { planId: entry[0], grams: entry[1] }; }), recurringError: recurringError, ready: unknown.length === 0 && (!frozen.length || !!method) };
  }
  function needsCleanup(cart, classify) {
    return (cart.items || []).some(function (line) {
      var props = line.properties || {}, facts = classify(line);
      return facts && (facts.frozen && Object.prototype.hasOwnProperty.call(props, 'Fulfillment preference') || !facts.frozen && props[property] != null);
    });
  }
  function createClient(options) {
    var fetcher = options.fetch, classify = options.classify, rootPath = options.root || '/', busy = false;
    async function request(path, body) {
      var response = await fetcher(rootPath + path, { method: body ? 'POST' : 'GET', credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json', 'Content-Type': 'application/json' }, body: body ? JSON.stringify(body) : undefined });
      if (!response.ok) throw Error('cart_unavailable');
      var cart = await response.json();
      if (!cart || !Array.isArray(cart.items)) throw Error('cart_unavailable');
      return cart;
    }
    async function read() { return request('cart.js'); }
    async function reconcile(method, route, expectedCartIdentity) {
      method = normalize(method);
      if (!method) throw Error('choose_method');
      if (busy) throw Error('busy');
      busy = true;
      try {
        var cart = await read(), original = identity(cart, true), limit = cart.items.length + 2;
        if (expectedCartIdentity != null && identity(cart, false) !== expectedCartIdentity) throw Error('cart_changed');
        if (analyze(cart, classify).unknown.length) throw Error('unknown_product');
        var expected = identity({ items: cart.items.map(function (line) { return Object.assign({}, line, { properties: deliveryProperties(line, classify(line), method, route) }); }) }, false);
        for (var count = 0; count < limit; count++) {
          var next = cart.items.find(function (line) {
            return JSON.stringify(stableProperties(line.properties)) !== JSON.stringify(stableProperties(deliveryProperties(line, classify(line), method, route)));
          });
          if (!next) break;
          var props = deliveryProperties(next, classify(next), method, route);
          cart = await request('cart/change.js', { id: next.key, quantity: next.quantity, properties: props });
          if (identity(cart, true) !== original) throw Error('cart_changed');
        }
        cart = await read();
        var state = analyze(cart, classify);
        if (identity(cart, false) !== expected || !state.ready || state.frozen.length && state.method !== method) throw Error('cart_changed');
        return cart;
      } finally { busy = false; }
    }
    async function saveMetadata(cart, metadata) {
      if (!metadata || !Object.keys(metadata).length) return cart;
      var updated = await request('cart/update.js', metadata);
      if (identity(updated, false) !== identity(cart, false)) throw Error('cart_changed');
      if (metadata.note != null && String(updated.note || '') !== metadata.note) throw Error('cart_changed');
      if (metadata.attributes && Object.keys(metadata.attributes).some(function (key) { return String((updated.attributes || {})[key] || '') !== metadata.attributes[key]; })) throw Error('cart_changed');
      return updated;
    }
    return { read: read, reconcile: reconcile, saveMetadata: saveMetadata };
  }
  var api = { property: property, routeProperties: routeProperties.slice(), normalize: normalize, planId: planId, identity: identity, classifier: classifier, analyze: analyze, createClient: createClient };
  if (!root || !root.document) return api;
  function start() {
    var node = document.getElementById('wtx-fulfillment-config');
    if (!node) return;
    var config;
    try { config = JSON.parse(node.textContent); } catch (error) { return; }
    if (config.active !== true || !/^\/(?:[a-z]{2}(?:-[A-Z]{2})?\/)?$/.test(config.root || '/')) return;
    var classify = classifier(config.items), client = createClient({ fetch: root.fetch.bind(root), root: config.root || '/', classify: classify });
    var copy = Object.assign({ refill_minimum: 'Each frozen refill shipment needs at least 40 lb on its own refill plan. Add frozen food to that plan, choose one-time for frozen food, or ask a coach.', refill_route_schedule: 'Frozen pickup and local delivery refills need a coach-confirmed schedule. Choose one-time for frozen food or ask a coach.', refill_plan_unavailable: 'This frozen refill plan could not be verified. Choose one-time for frozen food or ask a coach.', terms_needed: 'Accept the cart terms before continuing to checkout.', cleanup: 'Update cart delivery details', cleanup_note: 'Remove an earlier frozen-food delivery choice from these extras. Any route request remains a preference until stock and delivery are confirmed.', route_required: 'Choose an available route and stop for your frozen food, then save your delivery choice.', route_changed: 'Your route request is no longer available. Choose a current published date and save your delivery choice.', route_unavailable: 'Route availability could not be checked. Try again or ask a coach before checking out.' }, config.copy || {});
    var panels = [], selected = '', dirty = false, saving = false, checking = false, allowSubmit = null, lastCart = null, cartRevision = 0, readRevision = 0, releasingRebuy = false;
    var routes = root.WTXRouteHandoff, routeUrl = config.routeUrl || (config.root || '/') + 'pages/delivery-routes';
    function label(key) { return copy[key] || key; }
    function message(key) { panels.forEach(function (panel) { panel.querySelector('[data-wtx-fulfillment-status]').textContent = label(key); }); }
    function setBusy(value) { saving = value; panels.forEach(function (panel) { panel.setAttribute('aria-busy', String(value)); panel.inert = value; panel.querySelectorAll('button,input,select').forEach(function (input) { input.disabled = value; }); }); }
    function render(cart) {
      lastCart = cart;
      var state = analyze(cart, classify);
      var cleanupOnly = !state.frozen.length && !state.unknown.length && needsCleanup(cart, classify);
      if (!dirty) selected = state.method;
      panels.forEach(function (panel) {
        panel.hidden = !state.frozen.length && !state.unknown.length && !cleanupOnly;
        panel.querySelector('fieldset').hidden = cleanupOnly;
        panel.querySelector('[data-wtx-fulfillment-note]').textContent = label(cleanupOnly ? 'cleanup_note' : 'note');
        panel.querySelector('[data-wtx-fulfillment-save]').textContent = label(cleanupOnly ? 'cleanup' : 'save');
        panel.querySelectorAll('input[type=radio]').forEach(function (input) { input.checked = input.value === selected; });
        if (panel.wtxRoutePicker) {
          var savedRoute = !dirty && state.frozen.length && state.method === selected ? state.frozen[0].properties : undefined;
          panel.wtxRoutePicker.mount(panel.querySelector('[data-wtx-route-picker]'), { method: selected, properties: savedRoute });
        }
      });
      if (state.unknown.length) message('unknown_product');
      else if (dirty || needsCleanup(cart, classify)) message('save_needed');
      else if (state.conflict) message('conflict');
      else if (!state.ready) message('choose_method');
      else if (state.method === 'shipping' && state.restricted) message('restricted');
      else if (state.method === 'shipping' && state.grams < 18143.6) message('minimum');
      else if (state.recurringError) message(state.recurringError);
      else if (state.frozen.length && state.method !== 'shipping' && (!routes || state.frozen.some(function (line) { return !routes.validateProperties(line.properties, state.method); }))) message('route_required');
      else message('saved');
      return state;
    }
    async function refresh() {
      var revision = ++readRevision;
      try { var cart = await client.read(); return revision === readRevision ? render(cart) : null; } catch (error) { if (revision === readRevision) message(error.message); return null; }
    }
    function quantityValues(scope) {
      return Array.from(scope ? scope.querySelectorAll('[name="updates[]"]') : []).filter(function (input) { return !input.disabled; }).map(function (input) {
        return { key: input.getAttribute('data-line-key'), line: Number(input.getAttribute('data-line')), value: Number(input.value) };
      });
    }
    function quantitiesMatch(cart, values) {
      return values.every(function (input) {
        var line = input.key ? cart.items.find(function (item) { return item.key === input.key; }) : cart.items[input.line - 1];
        return !!line && input.value === line.quantity;
      });
    }
    function formMetadata(form) {
      var metadata = {};
      if (!form) return metadata;
      form.querySelectorAll('[name="note"],[name^="attributes["]').forEach(function (input) {
        if (input.disabled) return;
        if (input.name === 'note') { metadata.note = input.value; return; }
        var match = input.name.match(/^attributes\[([^\]]+)\]$/);
        if (!match) return;
        if (input.type === 'radio' && !input.checked) return;
        if (!metadata.attributes) metadata.attributes = {};
        metadata.attributes[match[1]] = input.type === 'checkbox' && !input.checked ? '' : input.value;
      });
      return metadata;
    }
    async function save(sourcePanel) {
      if (saving) return;
      var form = sourcePanel && !sourcePanel.closest('#rebuy-cart') && sourcePanel.closest('form');
      var quantities = quantityValues(form), metadata = formMetadata(form), revision = cartRevision;
      var frozenControls = [], previousInert = form && form.inert;
      if (form) form.inert = true;
      if (form) form.querySelectorAll('input,select,textarea,button').forEach(function (input) { frozenControls.push([input, input.disabled]); input.disabled = true; });
      setBusy(true); message('saving');
      try {
        var before = await client.read();
        if (!quantitiesMatch(before, quantities)) throw Error('review_quantity');
        var method = analyze(before, classify).frozen.length ? selected : 'shipping';
        var route = {};
        if (method !== 'shipping' && analyze(before, classify).frozen.length) {
          var picker = sourcePanel && sourcePanel.wtxRoutePicker;
          if (!picker) throw Error('route_unavailable');
          var selection = await picker.validate(method);
          if (!selection.ok) throw Error(selection.error || 'route_required');
          route = selection.properties;
          var current = await client.read();
          if (identity(current, false) !== identity(before, false)) throw Error('cart_changed');
          if (!quantitiesMatch(current, quantities)) throw Error('review_quantity');
        }
        if (revision !== cartRevision) throw Error('cart_changed');
        var saved = await client.reconcile(method, route, identity(before, false));
        saved = await client.saveMetadata(saved, metadata);
        dirty = false; render(saved);
        root.dispatchEvent(new CustomEvent('wtx:fulfillment-saved'));
        root.location.assign((config.root || '/') + 'cart');
      }
      catch (error) { message(error.message); }
      finally { setBusy(false); frozenControls.forEach(function (entry) { entry[0].disabled = entry[1]; }); if (form) form.inert = previousInert; }
    }
    function mount() {
      panels = panels.filter(function (panel) { return panel.isConnected !== false; });
      installRebuyGate();
      var targets = Array.from(document.querySelectorAll('[data-wtx-fulfillment-panel]'));
      var footer = document.querySelector('#rebuy-cart [data-rebuy-cart-anchor="footer"]') || document.querySelector('#rebuy-cart .rebuy-cart__flyout-actions');
      if (footer && !footer.querySelector('[data-wtx-fulfillment-panel]')) { var box = document.createElement('div'); box.setAttribute('data-wtx-fulfillment-panel', ''); footer.prepend(box); targets.push(box); }
      targets.forEach(function (panel) {
        if (panel.dataset.ready) return;
        panel.dataset.ready = 'true'; panel.className += ' wtx-fulfillment';
        var fieldset = document.createElement('fieldset'), legend = document.createElement('legend'), note = document.createElement('p');
        legend.textContent = label('title'); fieldset.appendChild(legend); note.textContent = label('note'); note.setAttribute('data-wtx-fulfillment-note', ''); panel.appendChild(note);
        var group = 'wtx-fulfillment-' + panels.length;
        ['shipping','pickup','local_delivery'].forEach(function (method) {
          var option = document.createElement('label'), input = document.createElement('input'), span = document.createElement('span');
          input.type = 'radio'; input.name = group; input.value = method; span.textContent = label(method);
          input.addEventListener('change', function () { selected = method; dirty = true; if (lastCart) render(lastCart); else message('save_needed'); });
          option.append(input, span); fieldset.appendChild(option);
        });
        panel.prepend(fieldset);
        var routeNode = document.createElement('div'); routeNode.setAttribute('data-wtx-route-picker', ''); panel.appendChild(routeNode);
        if (routes && typeof routes.createPicker === 'function') panel.wtxRoutePicker = routes.createPicker({ url: routeUrl, supportUrl: (config.root || '/') + 'pages/raw-feeding-plan?view=wtx-new#new-feeder-help', onChange: function () { if (!saving) { dirty = true; message('save_needed'); } } });
        var button = document.createElement('button'); button.type = 'button'; button.setAttribute('data-wtx-fulfillment-save', ''); button.textContent = label('save'); button.addEventListener('click', function () { return save(panel); }); panel.appendChild(button);
        var status = document.createElement('p'); status.setAttribute('data-wtx-fulfillment-status', ''); status.setAttribute('role','status'); status.setAttribute('aria-live','polite'); panel.appendChild(status); panels.push(panel);
        if (lastCart) render(lastCart); else refresh();
      });
      document.querySelectorAll('[data-wtpb-checkout-guidance]').forEach(function (el) { el.hidden = true; });
    }
    function focusPanel(preferRebuy) {
      var available = panels.filter(function (x) { return !x.hidden && x.isConnected !== false; });
      var panel = preferRebuy && available.find(function (x) { return x.closest('#rebuy-cart'); }) || available[0];
      if (panel) { panel.scrollIntoView({ block:'center', behavior:'smooth' }); (panel.querySelector('fieldset').hidden ? panel.querySelector('[data-wtx-fulfillment-save]') : panel.querySelector('input')).focus({ preventScroll:true }); }
      else root.location.assign((config.root || '/') + 'cart');
    }
    function rebuyTermsAccepted() {
      var smart = root.Rebuy && root.Rebuy.SmartCart;
      if (smart && typeof smart.hasTermsEnabled === 'function' && smart.hasTermsEnabled() && (typeof smart.hasAcceptedTerms !== 'function' || !smart.hasAcceptedTerms())) {
        message('terms_needed');
        var terms = document.getElementById('rebuy-terms-checkbox');
        if (terms) terms.focus();
        return false;
      }
      return true;
    }
    async function guardCheckout(continueCheckout, form, useRebuy) {
      if (saving || checking) return;
      if (dirty) { message('save_needed'); focusPanel(useRebuy); return; }
      if (form && !form.checkValidity()) { form.reportValidity(); return; }
      var terms = !useRebuy && document.querySelector('#terms');
      if (terms && !terms.checked) { terms.focus(); terms.reportValidity(); return; }
      if (useRebuy && !rebuyTermsAccepted()) return;
      var revision = cartRevision;
      checking = true;
      try {
        var cart = await client.read(), state = render(cart);
        if (dirty || saving) { message('save_needed'); focusPanel(useRebuy); return; }
        if (revision !== cartRevision) { message('cart_changed'); focusPanel(useRebuy); return; }
        if (form && !form.checkValidity()) { form.reportValidity(); return; }
        if (terms && !terms.checked) { terms.focus(); terms.reportValidity(); return; }
        if (useRebuy && !rebuyTermsAccepted()) return;
        if (!useRebuy && !quantitiesMatch(cart, quantityValues(form || document))) { message('review_quantity'); focusPanel(useRebuy); return; }
        var rebuyCart = useRebuy && root.Rebuy && root.Rebuy.Cart && root.Rebuy.Cart.cart;
        if (rebuyCart && Array.isArray(rebuyCart.items) && identity(rebuyCart, false) !== identity(cart, false)) { message('review_quantity'); focusPanel(useRebuy); return; }
        if (!state || !state.ready || state.recurringError || state.method === 'shipping' && (state.restricted || state.grams < 18143.6)) { focusPanel(useRebuy); return; }
        if (needsCleanup(cart, classify)) { message('save_needed'); focusPanel(useRebuy); return; }
        if (state.frozen.length) {
          if (!routes || typeof routes.validateCart !== 'function') { message('route_unavailable'); focusPanel(useRebuy); return; }
          var routeCheck = await routes.validateCart(cart, classify, { url: routeUrl });
          if (!routeCheck.ok) { message(routeCheck.error || 'route_required'); focusPanel(useRebuy); return; }
          if (state.method !== 'shipping') {
            var current = await client.read();
            if (dirty || saving || revision !== cartRevision || identity(current, false) !== identity(cart, false)) { message('cart_changed'); focusPanel(useRebuy); return; }
          }
        }
        if (dirty || saving || revision !== cartRevision) { message('cart_changed'); focusPanel(useRebuy); return; }
        if (useRebuy && !rebuyTermsAccepted()) return;
        if (form && !form.checkValidity()) { form.reportValidity(); return; }
        if (terms && !terms.checked) { terms.focus(); terms.reportValidity(); return; }
        checking = false;
        return continueCheckout();
      } catch (error) { message(error.message && copy[error.message] ? error.message : 'cart_unavailable'); }
      finally { checking = false; }
    }
    function installRebuyGate() {
      var rebuy = root.Rebuy;
      if (!rebuy) return;
      [[rebuy.SmartCart, 'checkout'], [rebuy.SmartCart, 'shopPayCheckout'], [rebuy.Cart, 'checkout'], [rebuy.Cart, 'goToShopifyCheckout']].forEach(function (entry) {
        var owner = entry[0], name = entry[1], original = owner && owner[name];
        if (typeof original !== 'function' || original.wtxFulfillmentGuard === true) return;
        var wrapped = function () {
          var context = this, args = arguments;
          if (releasingRebuy) return original.apply(context, args);
          return guardCheckout(function () {
            releasingRebuy = true;
            try { return original.apply(context, args); } finally { releasingRebuy = false; }
          }, null, true);
        };
        wrapped.wtxFulfillmentGuard = true;
        owner[name] = wrapped;
      });
    }
    function checkoutLink(target) {
      var link = target.closest && target.closest('a[href]');
      if (!link) return null;
      try { var url = new URL(link.href, root.location.href); return url.origin === root.location.origin && /\/checkout\/?$/.test(url.pathname) ? link : null; } catch (error) { return null; }
    }
    async function checkout(event) {
      if (event.type === 'submit' && event.target === allowSubmit) { allowSubmit = null; return; }
      var target = event.target.closest && event.target.closest('button[name="checkout"],input[name="checkout"],.cart-submit,.rebuy-cart__checkout-button,.rebuy-cart__shop-pay-button');
      if (!target && event.type === 'click') target = checkoutLink(event.target);
      if (event.type === 'submit') {
        target = event.submitter && event.submitter.matches('[name="checkout"]') ? event.submitter : null;
        if (!event.submitter && event.target.matches('form') && /\/cart\/?(?:\?.*)?$/.test(event.target.action || '')) target = event.target.querySelector('[name="checkout"]');
      }
      if (!target) return;
      event.preventDefault(); event.stopImmediatePropagation();
      if (target.disabled) return;
      var isRebuy = !!target.closest('#rebuy-cart') || target.matches('.rebuy-cart__checkout-button,.rebuy-cart__shop-pay-button');
      if (isRebuy) {
        installRebuyGate();
        var smart = root.Rebuy && root.Rebuy.SmartCart, name = target.matches('.rebuy-cart__shop-pay-button') ? 'shopPayCheckout' : 'checkout';
        if (smart && typeof smart[name] === 'function' && smart[name].wtxFulfillmentGuard === true) return smart[name]();
        root.location.assign((config.root || '/') + 'cart');
        return;
      }
      var form = target.form || (event.type === 'submit' ? event.target : null);
      var validationForm = form || target.closest('form');
      return guardCheckout(function () {
        if (form && typeof form.requestSubmit === 'function') {
          allowSubmit = form;
          try { form.requestSubmit(target); } finally { allowSubmit = null; }
        } else root.location.assign(target.tagName === 'A' ? target.href : (config.root || '/') + 'checkout');
      }, validationForm, false);
    }
    document.addEventListener('click', checkout, true);
    document.addEventListener('submit', checkout, true);
    var scheduled = false, nativeCartChanged = false;
    new MutationObserver(function (records) {
      if (records.some(function (record) {
        var target = record.target, area = target && target.closest && target.closest('.cart-items,.subtotal-row');
        return area && area.closest('[data-section-type="cart"]');
      })) { nativeCartChanged = true; cartRevision++; }
      if (scheduled) return;
      scheduled = true;
      root.requestAnimationFrame(function () {
        scheduled = false;
        var refreshNativeCart = nativeCartChanged; nativeCartChanged = false;
        mount();
        if (refreshNativeCart) refresh();
      });
    }).observe(document.body,{ childList:true, subtree:true });
    root.addEventListener('pageshow', refresh);
    ['rebuy.loaded','rebuy:cart.ready','rebuy:smartcart.ready','rebuy:smartcart.show','rebuy:cart.add','rebuy:cart.change'].forEach(function (name) {
      document.addEventListener(name, function () { cartRevision++; mount(); refresh(); });
    });
    document.addEventListener('change', function (event) { if (event.target.matches('[name="updates[]"]')) message('review_quantity'); });
    document.documentElement.classList.add('wtx-fulfillment-active');
    api.classify = classify; api.reconcileCart = client.reconcile; api.refresh = refresh;
    mount();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',start,{ once:true }); else start();
  return api;
}));
